import React, { useEffect, useContext, memo } from "react";
import api from "../../services/api";
import { UserContext } from "../../context/UserContext";
import { GlobalVariables } from "../../global";
import { notify } from "../../utils/notify";
import SelectCustom from "../../components/basic/SelectCustom";
import "./.promocode.css";

const Promocode = ({
  clienteCNPJ,
  promoters,
  setPromoters,
  usersPromoter,
  setUsersPromoter,
  optionsUsers,
  setOptionsUsers,
  optionsPromoters,
  setOptionsPromoters,
}) => {
  const { user } = useContext(UserContext);

  useEffect(() => {
    const getData = async () => {
      try {
        const cnpjRemoveMask = clienteCNPJ;
        const { data: result } = await api.get(
          `promocode/adm/cliente/${cnpjRemoveMask.replace(/[^0-9]+/g, "")}`
        );

        const data = result.data;

        if (data) {
          const dataPromoters = {};
          const dataUsersPromoters = {};

          dataPromoters.IdPromotorConsultor = data.promocode.IdPromotorConsultor
            ? data.promoters.find(
                (promt) => promt.CNPJ === data.promocode.IdPromotorConsultor
              )
            : null;

          dataPromoters.IdPromotorFranquia = data.promocode.IdPromotorFranquia
            ? data.promoters.find(
                (promt) => promt.CNPJ === data.promocode.IdPromotorFranquia
              )
            : null;

          dataPromoters.IdPromotorContador = data.promocode.IdPromotorContador
            ? data.promoters.find(
                (promt) => promt.CNPJ === data.promocode.IdPromotorContador
              )
            : null;

          dataPromoters.IdPromotorEntidade = data.promocode.IdPromotorEntidade
            ? data.promoters.find(
                (promt) => promt.CNPJ === data.promocode.IdPromotorEntidade
              )
            : null;

          dataUsersPromoters.IdUsuarioConsultor = data.promocode
            .IdUsuarioConsultor
            ? data.users.find(
                (usr) => usr.Id === data.promocode.IdUsuarioConsultor
              )
            : null;

          dataUsersPromoters.IdUsuarioFranquia = data.promocode
            .IdUsuarioFranquia
            ? data.users.find(
                (usr) => usr.Id === data.promocode.IdUsuarioFranquia
              )
            : null;

          dataUsersPromoters.IdUsuarioContador = data.promocode
            .IdUsuarioContador
            ? data.users.find(
                (usr) => usr.Id === data.promocode.IdUsuarioContador
              )
            : null;

          dataUsersPromoters.IdUsuarioEntidade = data.promocode
            .IdUsuarioEntidade
            ? data.users.find(
                (usr) => usr.Id === data.promocode.IdUsuarioEntidade
              )
            : null;

          setOptionsPromoters(data.promoters);
          setOptionsUsers(data.users);
          setPromoters(dataPromoters);
          setUsersPromoter(dataUsersPromoters);
        } else {
          setPromoters({
            IdPromotorConsultor: null,
            IdPromotorFranquia: null,
            IdPromotorContador: null,
            IdPromotorEntidade: null,
          });

          setUsersPromoter({
            IdUsuarioConsultor: null,
            IdUsuarioFranquia: null,
            IdUsuarioContador: null,
            IdUsuarioEntidade: null,
          });
        }
      } catch (error) {
        console.error("ERROR PromocodeEdit", error);
        notify("Não foi possível obter o promocode.");
      }
    };
    getData();
  }, [
    clienteCNPJ,
    setPromoters,
    setUsersPromoter,
    user.IdTipoUsuario,
    setOptionsPromoters,
    setOptionsUsers,
  ]);

  return (
    <div className="containerPromocode">
      <hr className="borderLineTop" />

      <label className="title">Promocode</label>

      <div className="containerRowAdd">
        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">Consultor</h6>
        </div>

        <div className="textListsPromocodeADM">
          <SelectCustom
            disabled={user.IdTipoUsuario !== GlobalVariables.ADM_QYON}
            label="Promotor"
            value={promoters.IdPromotorConsultor || null}
            onChange={(value) => {
              const copyPromoters = { ...promoters };
              copyPromoters.IdPromotorConsultor = value;
              setPromoters(copyPromoters);

              const usersCopy = { ...usersPromoter };
              usersCopy.IdUsuarioConsultor = null;
              setUsersPromoter(usersCopy);
            }}
            keyObject="Fantasia"
            key="select-consultor"
            optionsList={optionsPromoters.filter(
              (opt) =>
                opt.IdTipoPromotor ===
                parseInt(GlobalVariables.TIPO_PROMOTOR_CONSULTOR)
            )}
          />
        </div>

        <div className="textListsPromocodeADM">
          <SelectCustom
            disabled={user.IdTipoUsuario !== GlobalVariables.ADM_QYON}
            label="Usuário"
            value={usersPromoter.IdUsuarioConsultor || null}
            onChange={(value) => {
              const copyUsers = { ...usersPromoter };
              copyUsers.IdUsuarioConsultor = value;
              setUsersPromoter(copyUsers);
            }}
            keyObject="Nome"
            key="select-user-consultor"
            optionsList={optionsUsers.filter(
              (opt) =>
                promoters.IdPromotorConsultor &&
                opt.PromotorCNPJ === promoters.IdPromotorConsultor.CNPJ
            )}
          />
        </div>
      </div>

      <div className="containerRowAdd">
        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">Franquia</h6>
        </div>

        <div className="textListsPromocodeADM">
          <SelectCustom
            disabled={user.IdTipoUsuario !== GlobalVariables.ADM_QYON}
            label="Promotor"
            value={promoters.IdPromotorFranquia || null}
            onChange={(value) => {
              const copyPromoters = { ...promoters };
              copyPromoters.IdPromotorFranquia = value;
              setPromoters(copyPromoters);

              const usersCopy = { ...usersPromoter };
              usersCopy.IdUsuarioFranquia = null;
              setUsersPromoter(usersCopy);
            }}
            keyObject="Fantasia"
            key="select-franquia"
            optionsList={optionsPromoters.filter(
              (opt) =>
                opt.IdTipoPromotor ===
                parseInt(GlobalVariables.TIPO_PROMOTOR_FRANQUIA)
            )}
          />
        </div>

        <div className="textListsPromocodeADM">
          <SelectCustom
            disabled={user.IdTipoUsuario !== GlobalVariables.ADM_QYON}
            label="Usuário"
            value={usersPromoter.IdUsuarioFranquia || null}
            onChange={(value) => {
              const copyUsers = { ...usersPromoter };
              copyUsers.IdUsuarioFranquia = value;
              setUsersPromoter(copyUsers);
            }}
            keyObject="Nome"
            key="select-user-franquia"
            optionsList={optionsUsers.filter(
              (opt) =>
                promoters.IdPromotorFranquia &&
                opt.PromotorCNPJ === promoters.IdPromotorFranquia.CNPJ
            )}
          />
        </div>
      </div>

      <div className="containerRowAdd">
        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">Contador</h6>
        </div>

        <div className="textListsPromocodeADM">
          <SelectCustom
            disabled={user.IdTipoUsuario !== GlobalVariables.ADM_QYON}
            label="Promotor"
            value={promoters.IdPromotorContador || null}
            onChange={(value) => {
              const copyPromoters = { ...promoters };
              copyPromoters.IdPromotorContador = value;
              setPromoters(copyPromoters);

              const usersCopy = { ...usersPromoter };
              usersCopy.IdUsuarioContador = null;
              setUsersPromoter(usersCopy);
            }}
            keyObject="Fantasia"
            key="select-contador"
            optionsList={optionsPromoters.filter(
              (opt) =>
                opt.IdTipoPromotor ===
                parseInt(GlobalVariables.TIPO_PROMOTOR_CONTADOR)
            )}
          />
        </div>

        <div className="textListsPromocodeADM">
          <SelectCustom
            disabled={user.IdTipoUsuario !== GlobalVariables.ADM_QYON}
            label="Usuário"
            value={usersPromoter.IdUsuarioContador || null}
            onChange={(value) => {
              const copyUsers = { ...usersPromoter };
              copyUsers.IdUsuarioContador = value;
              setUsersPromoter(copyUsers);
            }}
            keyObject="Nome"
            key="select-user-contador"
            optionsList={optionsUsers.filter(
              (opt) =>
                promoters.IdPromotorContador &&
                opt.PromotorCNPJ === promoters.IdPromotorContador.CNPJ
            )}
          />
        </div>
      </div>

      <div className="containerRowAdd">
        <div className="textListsPromocodeADM">
          <h6 className="itemPromocode">Entidade</h6>
        </div>

        <div className="textListsPromocodeADM">
          <SelectCustom
            disabled={user.IdTipoUsuario !== GlobalVariables.ADM_QYON}
            label="Promotor"
            value={promoters.IdPromotorEntidade || null}
            onChange={(value) => {
              const copyPromoters = { ...promoters };
              copyPromoters.IdPromotorEntidade = value;
              setPromoters(copyPromoters);

              const usersCopy = { ...usersPromoter };
              usersCopy.IdUsuarioEntidade = null;
              setUsersPromoter(usersCopy);
            }}
            keyObject="Fantasia"
            key="select-entidade"
            optionsList={optionsPromoters.filter(
              (opt) =>
                opt.IdTipoPromotor ===
                parseInt(GlobalVariables.TIPO_PROMOTOR_ENTIDADE)
            )}
          />
        </div>

        <div className="textListsPromocodeADM">
          <SelectCustom
            disabled={user.IdTipoUsuario !== GlobalVariables.ADM_QYON}
            label="Usuário"
            value={usersPromoter.IdUsuarioEntidade || null}
            onChange={(value) => {
              const copyUsers = { ...usersPromoter };
              copyUsers.IdUsuarioEntidade = value;
              setUsersPromoter(copyUsers);
            }}
            keyObject="Nome"
            key="select-user-entidade"
            optionsList={optionsUsers.filter(
              (opt) =>
                promoters.IdPromotorEntidade &&
                opt.PromotorCNPJ === promoters.IdPromotorEntidade.CNPJ
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(Promocode);
